import { DispatchType, type DispatchesInfo } from '../types/businessTypes';
import type { Operation } from '../types/operation';

/**
 * True when there's more than one operation to choose from and the shopper
 * hasn't picked one yet — the item/fulfillment modal must ask first.
 */
export const isLocationSelectionRequired = (
  operations: Operation[],
  isLocationSelected: boolean,
) => operations.length > 1 && !isLocationSelected;

/**
 * True when the shopper is on the delivery flow but hasn't supplied a
 * delivery address yet — the item/fulfillment modal must ask first.
 */
export const isAddressSelectionRequired = (
  selectedDispatchType: DispatchType,
  dispatchesInfo: Partial<DispatchesInfo>,
) =>
  selectedDispatchType === DispatchType.DELIVERY &&
  !dispatchesInfo[DispatchType.DELIVERY]?.address;
